import React, { useEffect, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import ProjectsPanel from '../components/ProjectsPanel';
import { useDispatch, useSelector } from "react-redux";
import { setloadDrawer } from "../redux/slices/drawerSlice";
import { fetchNewProject, fetchAllUsers, fetchUsersByRole, fetchLOB, fetchClients } from '../redux/slices/newProjectSlice';
import { fetchChangeRequest } from '../redux/slices/changeRequestSlice';
import { fetchsupportRequest } from '../redux/slices/supportRequestSlice';
import CreateAndDownLoad from '../components/CreateAndDownLoad';
import { clearsearchFilter } from "../redux/slices/searchFilterSlice";
import { downloadProjects, downloadChangeRequests, downloadSupportRequests } from '../services/downloadServices';
import { errorNotifier } from '../components/Notification';

const Projects = () => {
    const dispatch = useDispatch();
    const Developer = 'developer';
    
    const [selectedTab, setSelectedTab] = useState('project');
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingChangeRequests, setIsDownloadingChangeRequests] = useState(false);
    const [isDownloadingSupportRequests, setIsDownloadingSupportRequests] = useState(false);

    useEffect(() => {
        dispatch(fetchChangeRequest());
        dispatch(fetchNewProject());
        dispatch(fetchAllUsers());
        dispatch(fetchClients());
        dispatch(fetchUsersByRole(Developer));
        dispatch(fetchLOB());
        dispatch(fetchsupportRequest());
        dispatch(clearsearchFilter());
    }, [dispatch]);
    
    const newProjects = useSelector((state) => state.newProject.projects) || [];
    const isEmpty = !newProjects || newProjects.length === 0;
  
    const changeRequestProjects = useSelector((state) => state.changeRequest.changeRequest) || [];
    const changeEmpty = !changeRequestProjects || changeRequestProjects.length === 0;
  
    const supportProjects = useSelector((state) => state.supportRequest.supportRequest) || [];
    const supportEmpty = !supportProjects || supportProjects.length === 0;
    
    const onClick = () => {
        dispatch(setloadDrawer({ status: true, type: "createProject" }));
    };
    
    const onChangeRequest = () => {
        dispatch(setloadDrawer({ status: true, type: "changeRequest" }));
    };
    
    const onSupportProject = () => {
        dispatch(setloadDrawer({ status: true, type: "supportRequest" }));
    };

    const handleDownload = async () => {
        if (isDownloading) return;
        
        try {
            setIsDownloading(true);
            const response = await downloadProjects();

            const blob = new Blob([response.data], { type: "text/csv" });

            const disposition = response.headers["content-disposition"];
            let filename = "projects_export.csv";
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename\*?=(?:UTF-8''|)([^;]+)/);
                if (match && match[1]) {
                    filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            errorNotifier("Failed to download projects. Please try again.");
        } finally {
            setIsDownloading(false);
        }
    };

    const handleDownloadChangeRequests = async () => {
        if (isDownloadingChangeRequests) return;
        
        try {
            setIsDownloadingChangeRequests(true);
            const response = await downloadChangeRequests();

            const blob = new Blob([response.data], { type: "text/csv" });

            const disposition = response.headers["content-disposition"];
            let filename = "changerequestprojects_export.csv";
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename\*?=(?:UTF-8''|)([^;]+)/);
                if (match && match[1]) {
                    filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            errorNotifier("Failed to download change requests. Please try again.");
        } finally {
            setIsDownloadingChangeRequests(false);
        }
    };

    const handleDownloadSupportRequests = async () => {
        if (isDownloadingSupportRequests) return;
        
        try {
            setIsDownloadingSupportRequests(true);
            const response = await downloadSupportRequests();

            const blob = new Blob([response.data], { type: "text/csv" });

            const disposition = response.headers["content-disposition"];
            let filename = "supportprojects_export.csv";
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename\*?=(?:UTF-8''|)([^;]+)/);
                if (match && match[1]) {
                    filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            errorNotifier("Failed to download support requests. Please try again.");
        } finally {
            setIsDownloadingSupportRequests(false);
        }
    };
    
    const project = {
        onClick: onClick,
        onDownload: handleDownload,
        createText: 'Create Project',
        btn_Text: isDownloading ? 'Downloading...' : 'Download',
        btn_Text_color: "#5CBF14",
        isDownloading: isDownloading,
        disabled: isDownloading
    }

    const changeRequest = {
        onClick: onChangeRequest,
        onDownload: handleDownloadChangeRequests,
        createText: 'Create Change Request',
        btn_Text: isDownloadingChangeRequests ? 'Downloading...' : 'Download',
        btn_Text_color: "#5CBF14",
        isDownloading: isDownloadingChangeRequests,
        disabled: isDownloadingChangeRequests
    }

    const support = {
        onClick: onSupportProject,
        onDownload: handleDownloadSupportRequests,
        createText: 'Create Support Request',
        btn_Text: isDownloadingSupportRequests ? 'Downloading...' : 'Download',
        btn_Text_color: "#5CBF14",
        isDownloading: isDownloadingSupportRequests,
        disabled: isDownloadingSupportRequests
    }

    return (
        <>
            <Box bg={'#FFFFFF'} py={'30px'}>
                <Flex flexDirection={['column', 'row', 'row']} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} borderBottom={'1px solid #B4B1B1'} py={'20px'} px={'20px'}>
                    <Text fontSize={'18px'} fontWeight={'400'}>Project</Text>
                    {(() => {
                        switch (selectedTab) {
                            case 'project':
                                return !isEmpty && (
                                    <CreateAndDownLoad {...project} />
                                );

                            case 'changeRequest':
                                return !changeEmpty && (
                                    <CreateAndDownLoad {...changeRequest} />
                                );

                            case 'support':
                                return !supportEmpty && (
                                    <CreateAndDownLoad {...support} />
                                );

                            default:
                                return null;
                        }
                    })()}
                </Flex>
                <Box py={5}>
                    <ProjectsPanel setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
                </Box>
            </Box>
        </>
    )
}

export default Projects;